import { observable } from "mobx";
import { Type } from "class-transformer";
import DomesticBankAccountResponse from "./domesticBankAccountResponse";
import TransactionType from "./transactionType";
import CardGatewayPaymentClassificationResponse from "./cardGatewayPaymentClassificationResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
class CardGatewayPaymentResponse {
  /**
   * Payment ID.
   */
  id!: string;

  @observable
  @Type(() => CardGatewayPaymentClassificationResponse)
  paymentClassification!: CardGatewayPaymentClassificationResponse;

  /**
   * Variable symbol.
   */
  @observable
  variableSymbol?: number;

  /**
   * Brutto amount.
   */
  @observable
  bruttoAmount!: number;

  /**
   * Authorized at.
   */
  @observable
  @Type(() => Date)
  authorizedAt!: Date;

  @observable
  transactionType!: TransactionType;

  /**
   * Auth code.
   */
  @observable
  authCode!: string;

  /**
   * Arn.
   */
  @observable
  arn!: string;

  /**
   * Payment ident.
   */
  @observable
  paymentIdent?: string;

  /**
   * Card number.
   */
  @observable
  cardNumber!: string;

  /**
   * Statement date.
   */
  @observable
  @Type(() => Date)
  statementDate!: Date;
}

export default class CardGatewayPayment extends CardGatewayPaymentResponse {
  @observable
  @Type(() => DomesticBankAccountResponse)
  merchantBankAccount!: DomesticBankAccountResponse;
}
